import ContentWrap from "../../DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "../../locales";

import { CommonWrap } from "@/PageComponents/common";

export default function PaymentAPIintroduction() {
  const { translate } = useLocales();
  return (
    <ContentWrap
      id="introduction"
      leftChildren={
        <CommonWrap>
          <Box component={"div"} className="title">
            {translate("payment_api_introduction.title")}
          </Box>
          <Box component={"div"} className="desc">
            {translate("payment_api_introduction.desc1")}
          </Box>
        </CommonWrap>
      }
    />
  );
}
